export default "__VITE_ASSET__7b9534d0__"